import { render, staticRenderFns } from "./step-case-category-details-panel.vue?vue&type=template&id=b1a5bda4&scoped=true&"
import script from "./step-case-category-details-panel.vue?vue&type=script&lang=js&"
export * from "./step-case-category-details-panel.vue?vue&type=script&lang=js&"
import style0 from "./step-case-category-details-panel.vue?vue&type=style&index=0&id=b1a5bda4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a5bda4",
  null
  
)

export default component.exports